import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useMemo } from 'react'

export const useIsIntegrationsV3 = (): boolean => {
  const workspace = useCurrentWorkspace()
  const isVirtualMarketer = !!workspace?.is_virtual_marketer

  const isEnabled = useMemo<boolean>(() => {
    return isVirtualMarketer
  }, [isVirtualMarketer])

  return isEnabled
}
